export default __webpack_public_path__ + "static/image-3-3e5884fb51c61d33f719147dceecc034.jpg";